import {api} from "../plugins/axios";
import {CouponApplyProductDto, TResponse, ViewUserCouponDto} from "../types/types";

export const getUserCoupons = (usedCouponType?: string) => {
    const params = {usedCouponType}
    return api.get<TResponse<ViewUserCouponDto[]>>(`/v1/coupon/user`, {params})
}

export const couponDownLoad = (data:{couponId: number}) => {
    return api.post(`/v1/coupon/download`, data)
}

export const checkCouponProduct = (couponCode:string, productIds:number[]) => {
    const params = {couponCode, productIds}
    return api.get<TResponse<CouponApplyProductDto[]>>(`/v1/coupon/checkCouponProduct`, {params})
}